{
  "loading": "Φόρτωση...",
  "placeholder": "Επιλογή…"
}
